import React from 'react';
import "../../styles/authentication/logout.css";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { firebaseAuth } from "../firebase/firebase_configuration";

const Logout = ({isLogoutShow, setLogoutShow}) => {
    const goTo = useNavigate();

    const onLogout = async () => {
        try {
            await signOut(firebaseAuth);
            setTimeout(() => {
                goTo("/login");
            }, 1000);
        } catch (error) {
            alert("Failed to logout");
            console.log(error.message);
        };
    };

    return(
        <div className={`logout_dialog ${isLogoutShow ? "show" : ""}`}>
            <div className="logout_overlay"></div>
            <div className="logout_content">
                <p className="logout_content_header">Confirm Logout</p>
                <p className="logout_content_text">Are you sure you want to logout?</p>
                <div className="logout_buttons_container">
                    <div className="logout_cancel_button" onClick={() => setLogoutShow(false)} >Cancel</div>
                    <div className="logout_button" onClick={() => onLogout()}>Logout</div>
                </div>
            </div>
        </div>
    );
}

export default Logout;